/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { ImgStyled } from '../../../../../components/common/Block/Img';
import { ITableCellStatusProps } from './types';

const StatusCell = ({ status, icon }: ITableCellStatusProps) => {
    return (
        <div style={{ display: 'flex ', alignItems: 'center' }}>
            {!!icon && <ImgStyled className="small" src={icon} style={{ marginRight: 4 }}/>}
            <span className="table__tooltip-text">
                {status}
            </span>
        </div>
    );
};

export default StatusCell;
